import { render, staticRenderFns } from "./FuelWidget.vue?vue&type=template&id=60df39d5&scoped=true&"
import script from "./FuelWidget.vue?vue&type=script&lang=ts&"
export * from "./FuelWidget.vue?vue&type=script&lang=ts&"
import style0 from "./FuelWidget.vue?vue&type=style&index=0&id=60df39d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df39d5",
  null
  
)

export default component.exports